export const offersData = [
    {
        key: 1,
        text: "Une réduction",
        value: "Une réduction"
    }
];

export const discountData = [
  {
    key: 1,
    text: "Euro",
    value: "value",
    image: {
      avatar: true,
      src:
        "https://s3-eu-west-3.amazonaws.com/tourismebyca/wp-content/uploads/2020/08/31150920/Coin.png",
    },
  },
  {
    key: 2,
    text: "Pour cent",
    value: "percent",
    image: {
      avatar: true,
      src:
        "https://s3-eu-west-3.amazonaws.com/tourismebyca/wp-content/uploads/2020/08/31150920/Coin.png",
    },
  },
];

export const thresholdData = [
    {
        key: 1,
        text: "Une valeur d'achat",
        value: "Basket" 
    },
    {
        key: 2,
        text: "Un nombre de points",
        value: "Points" 
    },
    {
        key: 3,
        text: "Un nombre de commandes",
        value: "Orders" 
    }
];
